<template>
  <div>
    <div class="air__utils__scrollTable mb-4">
      <a-table
        :rowKey="record => record.id"
        :columns="columns"
        :dataSource="data"
        :pagination="false"
        :scroll="{ x: '100%' }"
        :rowSelection="computedSelect"
        :loading="loading"
      >
        <template slot="name" slot-scope="name">
          <div>
            <div class="font-weight-bold">{{name}}</div>
            <!-- <div class="text-gray-4">{{user.position}}</div> -->
          </div>
        </template>
        <template slot="parent_category" slot-scope="parent_category">
          <div>{{parent_category ? parent_category.name : null}}</div>
        </template>
        <template slot="description" slot-scope="description">
          <div>{{description}}</div>
        </template>
        <template slot="action" slot-scope="record">
          <div class="text-nowrap">
            <a-tooltip
              placement="top"
              title="Edit category"
            >
              <a href="javascript:" class="btn btn-sm btn-light btn-with-addon mr-2" @click="showEditModal(record)">
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-edit" />
              </span>
                Edit
              </a>
            </a-tooltip>

            <a-tooltip
              placement="top"
              title="Delete category"
            >
              <a href="javascript:" class="btn btn-sm btn-danger btn-with-addon" @click="handleDelete(record)">
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-trash" />
              </span>
                Delete
              </a>
            </a-tooltip>
          </div>
        </template>
      </a-table>
    </div>

    <!-- <edit-school-class ref="editClass" @edited="handleEdited" /> -->
    <edit-category @onEdited="handleAfteredit"></edit-category>
  </div>
</template>

<script>
import EditCategory from '@/components/inventory/master/category/edit'

const columns = [
  { title: 'Name', dataIndex: 'name', scopedSlots: { customRender: 'name' } },
  { title: 'Parent Category', dataIndex: 'parent_category', scopedSlots: { customRender: 'parent_category' } },
  { title: 'Description', dataIndex: 'description', scopedSlots: { customRender: 'description' } },
  { title: 'Actions', className: 'text-right', scopedSlots: { customRender: 'action' } },
]
// const fakedata = [
//   { id: 1, name: 'Eletronics', description: 'Category for electronics items' },
//   { id: 2, name: 'Fashion', description: 'Category for Fashion items' },
//   { id: 3, name: 'Furniture', description: 'Category for Furniture items' }
// ]
// const exposedEvents = { OnSubmit: 'onsubmit', OnEdit: 'onedit', OnDelete: 'ondelete' }

export default {
  name: 'CategoryTable',
  components: {
    EditCategory,
  },
  props: {
    select: Boolean,
    loading: Boolean,
    rolesetting: { type: Object },
    data: {
      type: Array,
      default: () => [],
    },
  },
  data: function() {
    return {
      columns,
      showeditform: false,
      datatoedit: {},
    }
  },
  /* mounted: function () {
    this.fetchdata()
  }, */
  computed: {
    computedSelect: function() {
      if (!this.select) {
        return null
      }
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
      }
    },
  },
  methods: {
    /* fetchdata() {
      let api = '/api/inventory/product/stock/all'
      this.data.length = 0
      this.$http.get(api)
        .then((resp) => {
          this.data = resp.data.data
        })
        .catch(err => {
          console.error(err)
        })
    }, */
    handleAfteredit() {
      this.$emit('updateTable')
    },
    showInwardTransactionModal(record) {
      this.$eventBus.$emit('showInwardTransactionForm', record)
    },
    showOutwardTransactionModal(record) {
      this.$eventBus.$emit('showOutwardTransactionForm', record)
    },
    showEditModal(record) {
      this.$eventBus.$emit('openEditForm', record)
    },
    closeEditform() {
      this.showeditform = false
    },
    handleDelete(record) {
      this.$confirm({
        title: 'Are you sure to delete this record?',
        content: 'Clicking yes will delete this category.',
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: () => {
          this.$nprogress.start()
          this.$http
            .delete('/api/inventory/category/' + record.id)
            .then((resp) => {
              // this.$emit('updateTable')
              if (resp.status === 200) {
                this.$emit('updateTable') // Reload the table
                this.$nprogress.done()

                this.$notification['success']({
                  message: 'Deleted Successfully!',
                  description: 'The category has been deleted.',
                })
              } else {
                this.$notification['warning']({
                  message: 'Unknown Error',
                  description: 'There appears to be an error while submitting data. Please try again later.',
                })
              }
            })
            .catch(error => {
              this.$nprogress.done()
              this.$neoNotify.error(error)
            })
        },
        onCancel: () => {
          console.log('Cancel')
        },
      })
    },
  },
}
</script>

<style>

</style>
